import React, {useEffect, useState} from "react";
import styles from './GoogleLoginButton.module.scss';
import {Button} from '@material-ui/core';
import GoogleLogin from 'react-google-login';
import GoogleIcon from 'gui/components/icons/GoogleIcon';
import {config} from 'data/utils/constants';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

interface IGoogleLoginButtonProps {
  text: string;
  onSubmit: (formValues) => void;
  disabled: boolean;
  onlyAuth?: boolean;
  style?: any;
  onClick?: () => void;
  loading?: boolean;
}

const GoogleLoginButton = ({loading, ...props}: IGoogleLoginButtonProps) => {
  const [autoLoaded, setAutoLoaded] = useState((window as any).googleLoginLoaded || false);
  return (
    <GoogleLogin
      clientId={config.google.login}
      buttonText="Login"
      onAutoLoadFinished={(loaded) => {
        (window as any).googleLoginLoaded = true;
        setAutoLoaded(true);
      }}
      render={renderProps => (
        (loading || !autoLoaded) ? <SkeletonPlaceHolder
            className={styles.googleButton}
          /> :
          <Button
            className={`loginButtons ${styles.googleButton}`}
            fullWidth
            variant="contained"
            onClick={props.onClick || renderProps.onClick}
            disabled={renderProps.disabled}
            style={props.style}
          >
            {props.text}
            <GoogleIcon/>
          </Button>
      )}
      onSuccess={(r) => {
        props.onSubmit(r);
      }}
      onFailure={r => {
      }}
      cookiePolicy={'single_host_origin'}
    />
  );
};

GoogleLoginButton.defaultProps = {
  text: "התחבר עם גוגל",
  disabled: false,
  loading: false,
};

export default React.memo(GoogleLoginButton);
